
import COMMON_SETTINGS from '../settings/settings.common-settings';
import { mmMatches } from '../utils/utils.matchmedia';

import * as mobileNav from './components.site-navigation-mobile';
import * as desktopNav from './components.site-navigation-desktop';

const $ = jQuery;

const 	$siteNav = $('.js-site-nav'),
		elements = {
			$siteNav: $siteNav,
			$siteNavItem: $siteNav.find('.js-site-nav-item'),
			$siteNavItemWithChildren: $siteNav.find('.js-site-nav-item-with-children'),
			$subNav: $siteNav.find('.js-sub-nav'),
			$siteNavSubItemWithChildren: $siteNav.find('.js-site-nav-sub-item-with-children'),
			$subSubNav: $siteNav.find('.js-sub-sub-nav'),
			$navCheckbox: $('.js-nav-checkbox'),
			$navSubNavCheckboxes: $('.js-sub-nav-checkbox'),
			$navNavIconInside: $('.js-toggle-nav-icon-inside'),
			$subNavLabels: $('.js-sub-nav-label'),
			$labelText: $('.js-label-text'),
		},

		classes = {
			closeIcon: 'close-icon',
			isActive: 'is-active',
			isHovered: 'is-hovered'
		};

function iconToggle() {
	elements.$navCheckbox.on('click', function(e) {
		elements.$navNavIconInside.toggleClass(classes.closeIcon);
	});
}

function determineNavType() {
	return ( window.matchMedia( COMMON_SETTINGS.matchMediaBreakpoints.tablet ).matches ) ? 'DESKTOP' : 'MOBILE';
}

function watchForResize() {
	$(window).on('resize', activateCorrectNavigation);
}

function activateCorrectNavigation() {
	if ( determineNavType() === 'MOBILE' ) {
		mobileNav.init();
		desktopNav.reset();
	} else {
		desktopNav.init();
		mobileNav.reset();
	}
}

export function getElements() {
	return elements;
}

export function getClasses() {
	return classes;
}

function init() {
	
	if ( !elements.$siteNav.length ) return false;
	
	activateCorrectNavigation();
	watchForResize();
	iconToggle();
}

init();


